import moment from 'moment';

export default function formatDate(value, format = 'DD-MM-YYYY') {
  if (!value) return '';
  const date = moment(value);
  return `<span title="${date.format('DD-MM-YYYY HH:mm:ss')}">${date.format(format)}</span>`;
}
